export interface ImageRegistration {
  id: string;
  uploadUrl: {
    url: string;
    fields: {
      key: string;
      policy: string;
      'x-amz-algorithm': string;
      'x-amz-credential': string;
      'x-amz-date': string;
      'x-amz-signature': string;
    };
  };
}

export enum MunchedImageProxySize {
  'thumbnail' = 'thumbnail',
  'small' = 'small',
  'medium' = 'medium',
  'large' = 'large',
  'original' = 'original',
}

export interface MunchedImageProxy {
  id: string;
  width: number;
  height: number;
  fileType: string;
  signedDownloadUrl: string;
}

export interface MunchedImage {
  convertStatus: 'not_started' | 'running' | 'done' | 'error';
  filename: string;
  id: string;
  // See: lambdas/imageMuncher/munch_images.py for current proxies
  proxies?: Partial<Record<MunchedImageProxySize, MunchedImageProxy>>;
  signedDownloadUrl: string;
}
